/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { LeadProductInterestResponseDto } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class OrganisationLeadControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags organisation-lead-controller-v-2
   * @name GetLeadProductInterestByOrganisationId
   * @request GET:/api/v2/organisation/product-interest
   */
  getLeadProductInterestByOrganisationId = (params: RequestParams = {}) =>
    this.http.request<LeadProductInterestResponseDto, any>({
      path: `/v2/organisation/product-interest`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getLeadProductInterestByOrganisationIdPath = '/v2/organisation/product-interest'
  static getLeadProductInterestByOrganisationIdMethod = 'GET'
}
